import { Notify } from "@/components/ui/notify";
import type { AppliedScenario } from "@/types/applied-scenario.types";
import { useAppliedScenario } from "./hooks/useAppliedScenario";
import { AdherencePanel } from "./AdherencePanel";

interface AdherenceSectionProps {
  scenario: AppliedScenario;
}

// A aderência aberta de UM compromisso em vigência.
// Por que consultar o DETALHE em vez de usar o que a lista já trouxe: são coisas diferentes. A
// lista mostra a última VIRADA registrada (barata, e é ela que permite varrer dezenas de
// compromissos sem custo); aqui o servidor RECALCULA contra os fatos de agora. Quem abriu este
// painel quer saber como está neste minuto, não como estava no último ciclo — e é a única
// superfície em que o custo das quatro leituras se paga.

export function AdherenceSection({ scenario }: AdherenceSectionProps) {
  const detail = useAppliedScenario(scenario.id);

  if (detail.isError) {
    return (
      <Notify.QueryError
        error={detail.error}
        onRetry={() => void detail.refetch()}
        title="Não foi possível carregar a aderência"
      />
    );
  }
  if (detail.isPending) {
    return <p className="text-sm text-muted-foreground">Avaliando a aderência…</p>;
  }

  return (
    <AdherencePanel
      adherence={detail.data.adherence}
      thresholdPct={detail.data.adherenceThresholdPct}
    />
  );
}
